module.exports = __webpack_public_path__ + "img/close.df54008b.svg";